// extracted by mini-css-extract-plugin
module.exports = {"container":"FormRegister_container__2beSy"};